import { Injectable, InjectionToken, OnDestroy } from "@angular/core";
import { TreeApi, TreeService } from "@mydocma/component-library/src/lib/tree";
import { MediatorService } from "@mydocma/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { BehaviorSubject, Subject } from "rxjs";
import {ProjectStructureNode} from "@mydocma/project";

export const STRUCTURE_SYNC_TASK_DISABLED = new InjectionToken<boolean>('STRUCTURE_SYNC_TASK_DISABLED');

export interface StructureEventData {
  node: any;
  tree: ProjectStructureNode
}

export interface StructureReorderEventData extends StructureEventData {
  parentId: string;
  newSortId: number;
}
export enum CoEvent {
    StructureTreeReady,

    StructureCreated,
    StructureUpdated,
    StructureDeleted,
    StructureReordered,

    PlanCreated,
    PlanDeleted,
    PlanUpdated,

    BimModelCreated,
    BimModelDeleted,
    BimModelUpdated
}


@UntilDestroy()
@Injectable({providedIn: 'root'})
export class CoEventService implements OnDestroy {

    private projectStructureTreeReadySubject = new BehaviorSubject<TreeApi>(null);
    public onProjectStructureTreeReady = this.projectStructureTreeReadySubject.asObservable();

    private planCreatedSubject = new Subject<any>();
    private planDeletedSubject = new Subject<any>();
    private planUpdatedSubject = new Subject<any>();
    public onPlanCreated = this.planCreatedSubject.asObservable();
    public onPlanDeleted = this.planDeletedSubject.asObservable();
    public onPlanUpdated = this.planUpdatedSubject.asObservable();

    private bimModelCreatedSubject = new Subject<any>();
    private bimModelDeletedSubject = new Subject<any>();
    private bimModelUpdatedSubject = new Subject<any>();
    public onBimModelCreated = this.bimModelCreatedSubject.asObservable();
    public onBimModelDeleted = this.bimModelDeletedSubject.asObservable();
    public onBimModelUpdated = this.bimModelUpdatedSubject.asObservable();

    private structureCreatedSubject = new Subject<StructureEventData>();
    private structureUpdatedSubject = new Subject<StructureEventData>();
    private structureDeletedSubject = new Subject<StructureEventData>();
    private structureReorderedSubject = new Subject<StructureReorderEventData>();
    public onStructureCreated = this.structureCreatedSubject.asObservable();
    public onStructureUpdated = this.structureUpdatedSubject.asObservable();
    public onStructureDeleted = this.structureDeletedSubject.asObservable();
    public onStructureReordered = this.structureReorderedSubject.asObservable();

    constructor(private readonly mediatorService: MediatorService) {
      this.mediatorService.subscribe('structure-tree-ready', 'bp-event-service', (treeApi: TreeApi) => {
        this.projectStructureTreeReadySubject.next(treeApi);
      });
    }

    public emit(eventType: CoEvent, data: any) {
        switch(eventType) {
            case CoEvent.PlanCreated:
                this.planCreatedSubject.next(data);
                break;
            case CoEvent.PlanDeleted:
                this.planDeletedSubject.next(data);
                break;
            case CoEvent.PlanUpdated:
                this.planUpdatedSubject.next(data);
                break;
            case CoEvent.BimModelCreated:
                this.bimModelCreatedSubject.next(data);
                break;
            case CoEvent.BimModelDeleted:
                this.bimModelDeletedSubject.next(data);
                break;
            case CoEvent.BimModelUpdated:
                this.bimModelUpdatedSubject.next(data);
                break;
            case CoEvent.StructureCreated:
                this.structureCreatedSubject.next(data);
                break;
            case CoEvent.StructureUpdated:
                this.structureUpdatedSubject.next(data);
                break;
            case CoEvent.StructureDeleted:
                this.structureDeletedSubject.next(data);
                break;
            case CoEvent.StructureReordered:
                this.structureReorderedSubject.next(data);
                break;
            case CoEvent.StructureTreeReady:
                this.projectStructureTreeReadySubject.next(data);
                break;
            default:
        }
    }

    ngOnDestroy(): void {}
}
